import React, { useState, useEffect } from 'react'

//import { motion } from 'framer-motion'
import {Link, BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom'

import Header from "./Header"
import CardProfile from "./StaticCard/CardProfile"
import AboutCard from "./Cards/About/AboutCard"
import ResumeCard from "./Cards/Resume/ResumeCard"
import Projects from "./Cards/Projects/Projects"
import Blog from "./Cards/Blog/Blog"
import ContactCard from "./Cards/Contact/ContactCard"

const Container = () => {
    return (
        <div className="container opened" data-animation-in="fadeInLeft" data-animation-out="fadeOutLeft">
            <Header />
            <CardProfile />
            <Switch>
                <Route exact path="/">
                    <AboutCard />
                </Route>
                <Route path="/resume">
                    <ResumeCard />
                </Route>
                <Route path="/projects">
                    <Projects />
                </Route>
                <Route path="/blog">
                    <Blog />
                </Route>
                <Route path="/contactme">
                    <ContactCard />
                </Route>
                <Route>
                    <Redirect to="/" />
                </Route>
            </Switch>
        </div>
    );
}

export default Container;